import { BuilderCanvas } from "../components/BuilderCanvas";
import { CheckoutPreview } from "./CheckoutPreview";

export const Canvas = () => (
  <BuilderCanvas>
    <CheckoutPreview />
  </BuilderCanvas>
);
